import axios from 'axios';
import {
  EventData,
  EventListResponse,
  GetEventsQuery,
} from '../types/event';

const buildParams = (query: GetEventsQuery): URLSearchParams => {
  const params = new URLSearchParams();
  if (query.year)          params.append('year',          String(query.year));
  if (query.month)         params.append('month',         String(query.month));
  if (query.date)          params.append('date',          query.date);
  if (query.date_from)     params.append('date_from',     query.date_from);
  if (query.date_to)       params.append('date_to',       query.date_to);
  if (query.category)      params.append('category',      query.category);
  if (query.industry)      params.append('industry',      query.industry);
  if (query.company_scale) params.append('company_scale', query.company_scale);
  if (query.creator_type)              params.append('creator_type', query.creator_type);
  if (query.tag_slug)                  params.append('tag_slug',     query.tag_slug);
  if (query.own_only)                  params.append('own_only',     query.own_only);
  if (query.page)                      params.append('page',      String(query.page));
  if (query.limit)                     params.append('limit',     String(query.limit));
  if (query.past_only !== undefined)   params.append('past_only', String(query.past_only));
  return params;
};

export const eventService = {
  /** EVT-01: イベント一覧取得 */
  getEvents: async (query: GetEventsQuery = {}): Promise<EventListResponse> => {
    const params = buildParams(query);
    const res = await axios.get(`/api/events?${params.toString()}`, {
      withCredentials: true,
    });
    return res.data.data;
  },

  /** EVT-02: イベント作成 */
  createEvent: async (body: Partial<EventData>): Promise<EventData> => {
    const res = await axios.post('/api/events', body, { withCredentials: true });
    return res.data.data;
  },

  /** EVT-03: イベント詳細取得 */
  getEventById: async (id: number): Promise<EventData> => {
    const res = await axios.get(`/api/events/${id}`, { withCredentials: true });
    return res.data.data;
  },

  /** EVT-04: イベント更新 */
  updateEvent: async (id: number, body: Partial<EventData>): Promise<EventData> => {
    const res = await axios.put(`/api/events/${id}`, body, { withCredentials: true });
    return res.data.data;
  },

  /** EVT-05: イベント削除 */
  deleteEvent: async (id: number): Promise<void> => {
    await axios.delete(`/api/events/${id}`, { withCredentials: true });
  },

  /** EVT-06: 参加申込（profileData は申込フォームで入力したプロフィール補完データ） */
  participate: async (id: number, profileData?: Record<string, string>): Promise<void> => {
    await axios.post(`/api/events/${id}/participate`, profileData ?? {}, { withCredentials: true });
  },

  /** EVT-07: 参加キャンセル */
  cancelParticipation: async (id: number): Promise<void> => {
    await axios.delete(`/api/events/${id}/participate`, { withCredentials: true });
  },

  /** EVT-08: 参加者一覧取得 */
  getParticipants: async (id: number) => {
    const res = await axios.get(`/api/events/${id}/participants`, { withCredentials: true });
    return res.data.data;
  },
};
